import moment from 'moment';
import Config from 'config';
import DateUtils from 'utils/date';
import TimeUtils from 'utils/time';

function roundStartTime(datetime, timezone) {
    const dt = datetime ? moment(datetime) : moment().tz(timezone);

    return dt.minutes() < 30 ? dt.minute(0) : dt.minute(30);
}

export function createTimeWindowParams(page, query, timezone) {
    const {starts: startsParam, ends: endsParam} = query;

    if (startsParam && endsParam) {
        return {starts: startsParam, ends: endsParam};
    }

    const starts = roundStartTime(startsParam, timezone);
    const ends = moment(starts).add(moment.duration(3, 'hours'));
    const airportEndDate = moment(starts).add(moment.duration(3, 'days'));

    if (page === 'airport') {
        return {
            starts: DateUtils.combineDateAndTime(
                starts,
                TimeUtils.getAsMoment('07:00 AM')
            ).format(Config.apiDateTimeFormat),
            ends: DateUtils.combineDateAndTime(
                airportEndDate,
                TimeUtils.getAsMoment('11:00 PM')
            ).format(Config.apiDateTimeFormat),
        };
    } else {
        return {
            starts: starts.format(Config.apiDateTimeFormat),
            ends: ends.format(Config.apiDateTimeFormat),
        };
    }
}
